import {Actions, createEffect, ofType} from '@ngrx/effects';
import { Injectable, inject } from '@angular/core';
import {AssignmentSolutionsDbService} from '../services/assignment-solutions-db.service';
import {AssignmentSolutionActions, LessonActions} from './action-types';
import {concatMap, filter, map, withLatestFrom, catchError} from 'rxjs/operators';
import {AppState} from './index';
import {select, Store} from '@ngrx/store';
import {selectActiveLesson, selectUser} from './selectors';
import {selectActiveLessonAssigmentSolution} from './assigmnent-solutions.selectors';
import {assignmentSolutionLoaded} from './assignment-solutions.actions';
import {EMPTY} from 'rxjs';


@Injectable()
export class AssignmentSolutionEffects {
  private store = inject<Store<AppState>>(Store);
  private actions$ = inject(Actions);
  private assignmentSolutionsDB = inject(AssignmentSolutionsDbService);


  createNewAssignmentSolution$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AssignmentSolutionActions.assignmentSolutionCreated),
      concatMap(action => this.assignmentSolutionsDB.createNewAssigmentSolution(action.solution)),
      map(solution => assignmentSolutionLoaded({solution}))
    )
  );


  loadAssignmentSolutionIfNeeded$ = createEffect( () =>
    this.actions$.pipe(
      ofType(LessonActions.watchLesson),
      withLatestFrom(
        this.store.pipe(select(selectActiveLesson)),
        this.store.pipe(select(selectActiveLessonAssigmentSolution)),
        this.store.pipe(select(selectUser)),
      ),
      filter(([action, lesson, solution, user]) => lesson.type == "assignment"),
      concatMap(([action, lesson, solution, user]) => this.assignmentSolutionsDB.loadLatestAssignmentSolutionForLesson(lesson.id, user.id)),
      filter(solution => !!solution),
      map(solution => assignmentSolutionLoaded({solution}))
    ));

  // Deletes previous assignment solution when a new one is uploaded
  deleteOldAssignmentSolution$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AssignmentSolutionActions.assignmentSolutionPurged),
      concatMap(action => 
        this.assignmentSolutionsDB.getAssignmentSolutionById(action.assignmentSolutionId).pipe(
          concatMap(oldSolution => {
            if (!oldSolution) {
              return EMPTY;
            }
            return this.assignmentSolutionsDB.deleteAssignmentSolutionWithFile(oldSolution);
          }),
          catchError(err => {
            console.error('Failed to delete old assignment solution:', err);
            return EMPTY;
          })
        )
      )
    ),
    { dispatch: false }
  );

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {


  }

}
